import React, { Component } from 'react';
import Panel from './components/Panel';
import Strip from './components/Strip';
import Character from './components/Character';
import Balloon from './components/Balloon';
import fabric from 'fabric-webpack';

module.exports = {
    Panel,
    Strip,
    Balloon,
    Character
};


/** WEBPACK FOOTER **
 ** ./src/Komik.js
 **/